module.exports = __webpack_public_path__ + "assets/img/scale.91b22b71.svg";